import { render, staticRenderFns } from "./OverseasPdf.vue?vue&type=template&id=1d993a5e&scoped=true&"
import script from "./OverseasPdf.vue?vue&type=script&lang=js&"
export * from "./OverseasPdf.vue?vue&type=script&lang=js&"
import style0 from "./OverseasPdf.vue?vue&type=style&index=0&id=1d993a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d993a5e",
  null
  
)

export default component.exports